import { useState } from "react"
import uniqueId from "lodash/uniqueId";

function useUniqueId(prefix?: string | undefined) {
   const [id] = useState(() => uniqueId(prefix));
   return id;
}

export default useUniqueId;